/*
----- Typography ----- 

This module has basically morphed into axis-tables.js ..... 

- This handles responsive tables i.e copies the header columns content into their content row s for mobiles view labels as we don't show table headers in mobile.
- 
*/


// Configuration.
// Elements that are support to be toggled by row click.
const supportedRowControlToggleInputs = ['radio', 'checkbox'];

var instances = {};

// Instances get / set functions.
function setContext(id, value) {
    instances[id]['context'] = value;
    return instances[id]['context'];
}
function getContext(id) {
    return instances[id]['context'];
}
function setContainer(id, value) {
    return instances[id]['container'] = value;
}
function getContainer(id) {
    return instances[id]['container'];
}
function setResponseRowConfig(id, value) {
    instances[id]['responsive-table']['rows'] = value;
    return instances[id]['responsive-table']['rows'];
}
function getResponsiveRowConfig(id) {
    return instances[id]['responsive-table']['rows'];
}

function initialiseAlltables() {
    let responsiveTables = expressSelectors()['cms']['tables'];
    // Added the generic attribute to this list of initialisers.
    responsiveTables = responsiveTables + ', [' + expressSelectors()['tables']['responsive-tables'] + ']';
    if ($(responsiveTables).length > 0) {
        $(responsiveTables).each(function() {
            // Grab context.
            let context = $(this);
            // Initialise.
            let init = initialiseTables(context);
        });
    }
}

// Added table head content to tbody columns for mobile view.
function initialiseTables(context) {
    // If a table id is assign then this table has already been initialised, we currently do no support re-initialisation, a de-initialisation process will need to be thoughtout first.
    if (context.attr('table-id')) {
        return true;
    }
    // Generate unique id ( as this is most likely a cms table ).
    let id = "table-" + generateId();
    // Assign id to the table.
    context.attr('table-id', id);
    // Check if this is a comparison table if it is then skip.
    if (context.attr(expressSelectors()['tables']['comparison-tables']) != undefined) {
        return false;
    }
    // Create instance.
    let instance = instances[id] = {};
    // Set instance context.
    setContext(id, context);
    // Does this table have scrolling enabled?
    const isScrollable = (context.attr(expressSelectors()['tables']['table-scrollable']) != undefined);
    if (isScrollable) {
        const scrollableInit = initialiseScrollableTable(id);
    }
    // Get all table headings.
    let labels = [];
    $(context).find('th').each(function(key, value) {
        // Column Context.
        let columnContext = $(value);
        // Should we be ignoring this column label?
        let ignore = (columnContext.attr(expressSelectors()['tables']['mobile-label-ignore']) != undefined);
        // Column heading text.
        let heading = columnContext.text();
        // Column config.
        let columnConfig = {};
        // Add properties to config.
        columnConfig['heading'] = heading;
        columnConfig['ignore'] = ignore;
        // Add config to heading array.
        labels.push(columnConfig);
    });
    instance['labels'] = labels;
    // Add mobile lables.
    let initaliseLabels = addMobileLabels(id);
    // Add class.
    context.addClass('responsive-table stack');
    // If this is a responsive table that reveals its rows in mobile then initialise.
    if (context.attr('responsive-reveal') != undefined) {
        responsiveTableInit(id);
    } else {
        // For rows that have images, details get shifted to the right ( column 2 ) and the image stays left ( column 1 ) in order for the image to span all rows we have to count how many rows ( table columns ) as the css has no context of this and the grid layout current doesn't support spanning to the last track of an implicit grid, for the css to remain generic we cannot specify row count and this gets used on multiple tables in different context's.
        // https://github.com/w3c/csswg-drafts/issues/2402
        // https://github.com/w3c/csswg-drafts/issues/5852
        let hasImageColumn = (context.find('td[class*="image-col"]').length > 0);
        if (hasImageColumn) {
            // Select first row columns, this is based on the theory that a table row will only ever have one image and that all rows have the same td count, if this is no longer the case then a row by row calulation would need to be done.
            let firstRowColumns = context.find('tbody tr:first-child');
            // Count how many rows we need to span based on td's, exlude image column.
            let rowSpan = firstRowColumns.find('td:not([class*="image-col"])').length;
            // Find image image columns.
            let imageColumns = context.find('td.image-col');
            // Add row span.
            imageColumns.css('grid-row','1 / span ' + rowSpan);
        }
    }
    // Check for row input toggle instances.
    const rowInputToggles = context.find('tr[' + expressSelectors()['tables']['row-input-toggle']  + ']');
    if (rowInputToggles.length) {
        // Loop over initialising.
        rowInputToggles.each(function() {
            const toggle = $(this);
            const init = rowInputToggleInitialise(toggle);
        });
    }
}

// Scrollable tables.
function initialiseScrollableTable(id) {
    // Get context.
    let context = getContext(id);
    // Get the table name, the n ame is require so the max height can be applied via the CSS.
    const name = context.attr(expressSelectors()['tables']['table-scrollable']);
    // Check whether wrapped in a table container.
    if (!context.parent('[' + expressSelectors()['tables']['table-container'] + ']').length) {
        // Wrap table.
        context.wrap(`<div ${expressSelectors()['tables']['table-container']}="${id}" class="table-container"></div>`);
    }
    // Get container context.
    const container = context.parent('[' + expressSelectors()['tables']['table-container'] + ']');
    setContainer(id, container);
    // Add class.
    container.addClass('table-scroll-enabled ' + name);
    // Check if scroll shadow is needed.
    updateScrollShadow(id);
    // Added scroll listener + handler.
    container.on('scroll', function() {
        updateScrollShadow(id);
    });
}

// Use box-shadow to signal to the user there is more content to be seen if they scroll.
function updateScrollShadow(id) {
    const container = getContainer(id);
    const scrollTop = container.scrollTop();
    const scrollHeight = container[0].scrollHeight;
    const clientHeight = container[0].clientHeight;
    // Detect if at Top or Bottom of container.
    const isAtTop = scrollTop === 0;
    const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    // Reset classes.
    container.removeClass('scroll-at-top scroll-at-bottom scroll-middle');
    // Add class depending on scroll position.
    if (isAtTop && isAtBottom) {
        // No class required due to too little content.
    } else if (isAtTop) {
        container.addClass('scroll-at-top');
    } else if (isAtBottom) {
        container.addClass('scroll-at-bottom');
    } else {
        container.addClass('scroll-middle')
    }
}

// Initialiser for responsive table reveal.
function responsiveTableInit(id) {
    // Get context.
    let context = getContext(id);
    // Add create header config in instance.
    instances[id]['responsive-table'] = {};
    // Holds table rows.
    let rows = [];
    context.find('tbody tr').each(function() {
        // Row context.
        let row = $(this);
        // Create row config.
        let rowConfig = {};
        rowConfig['header'] = {}, rowConfig['header']['items'] = [], rowConfig['header']['column-classes'] = [];
        rowConfig['content'] = {}, rowConfig['content']['items'] = [], rowConfig['content']['column-classes'] = [];
        // Add row classes.
        rowConfig['row-classes'] = row.attr('class');
        // Loop through each column.
        row.find('td').each(function() {
            // Column context.
            let column = $(this);
            // Find out if this is a header item.
            let isHeaderItem = (column.attr(expressSelectors()['tables']['responsive-header-item']) != undefined ? true : false);
            if (isHeaderItem) {
                let children = column.children(':not(.col-label)');
                let childrenMarkup = "";
                // Loop over children collecting markup.
                $.each(children, (i, child) => {
                    let childMarkup = child.outerHTML;
                    childrenMarkup += childMarkup;
                });
                rowConfig['header']['items'].push(childrenMarkup);
                rowConfig['header']['column-classes'].push(column.attr('class'));
            } else {
                rowConfig['content']['items'].push(column.prop('outerHTML'));
                rowConfig['content']['column-classes'].push(column.attr('class'));
            }
        });
        rows.push(rowConfig);
    });
    // Add data to instance.
    setResponseRowConfig(id, rows);
    // Markup string that everything gets put into.
    let markup = "";
    $.each(getResponsiveRowConfig(id), function(row, value) {
        // Build header.
        let header = buildHeaderTemplate(id, row);
        // Build content.
        let content = buildContentTemplate(id, row);
        // Add header + content together and wrap them.
        markup = markup + `<div class="responsive-table-item ${getResponsiveRowConfig(id)[row]['row-classes']}" reveal-item>${header + content}</div>`;
    });
    // Wrap everything.
    markup = `<div class="responsive-reveal-table" responsive-table-id="${id}">${markup}</div>`;
    // Add to DOM.
    context.before(markup);

    // Add listener(s).
    // Click.
    let table = $('[responsive-table-id=' + id + ']');

    table.on('click', '[reveal-header]', function(event) {
        // To prevent bubbling from tooltips.
        if ($(event.target).is('[tooltip-trigger]')) return;
        // Grab context.
        let context = $(this);
        // Find container.
        let container = context.parents('[reveal-item]');
        // Toggle class.
        container.toggleClass('active');
    });
}

function buildHeaderTemplate(id, row) {
    // Get row config.
    let config = getResponsiveRowConfig(id)[row];
    // Markup string that gets generated.
    let markup = "";
    // Loop the items.
    $.each(config['header']['items'], function(column, value) {
        // Add item to string.
        markup = markup + `<div class="header-item ${config['header']['column-classes'][column]}">${value}</div>`;
    });
    // Wrap items.
    markup = `<div class="header-container" reveal-header>${markup}</div>`;
    return markup;
}

function buildContentTemplate(id, row) {
    // Get row config.
    let config = getResponsiveRowConfig(id)[row];
    // Mark string that get generated.
    let markup = "";
    // Loop the items.
    $.each(config['content']['items'], function(column, value) {
        // Add item to string.
        markup = markup + `<div class="content-item ${config['content']['column-classes'][column]}">${value}</div>`;
    });
    // Wrap items.
    markup = `<div class="content-container">${markup}</div>`;
    return markup;
}

// Comparison tables, essetially header down the side and across the top of the table, then in mobile have a tabbed view.
function initialiseAllComparisionTables() {
    let comparisonTables = $('[' + expressSelectors()['tables']['comparison-tables'] + ']');
    if (comparisonTables.length > 0) {
        comparisonTables.each(function(key, value) {
            // Grab context.
            let context = $(this);
            // Initialise.
            let init = comparisonTableInitialise(context);
            
        });
    }
} 



function comparisonTableInitialise(context) {
    // Wrap table in container.
    context.wrap("<div class='comparison-table-container'></div>");
    // Put table into context.
    let container = context.parents('.comparison-table-container');
    // Config
    // When in mobile should we show summary row ( comparison heading + currently selected )
    let showSummaryRow = (context.attr('data-comparison-table-show-summary-row') != undefined);
    // Used to hold column header content.
    let columnNames = [];
    // Extract header content.
    context.find('thead tr th').each(function(key, value) {
        let name = $(this).html();
        // Remove white space.
        name = name.replace(/&nbsp;/g, '');
        // Skip the first field as this is normally just a label for the comparison column.
        if (key > 0) {
            columnNames.push(name);
        }
    });
    // Add table class.
    context.addClass('comparison-table');
    // Add tbody values class for css.
    context.find('tbody').addClass('comparison-values');
    // Get the comparison column heading.
    let comparisonColumnHeading = context.find('thead tr > th').html().replace(/&nbsp;/g, '');
    // Buttons for toggling columns in mobile.
    let buttons = "";
    // Build buttons to switch between columns.
    $.each(columnNames, function(key, value) {
        key = key + 2;
        buttons = buttons + `<li><button type="button" comparison-table-button table-index="${key}" class="comparison-table-button">${value}</button>`;
    });
    // Wrap buttons.
    buttons = `
        <div class="comparison-table-buttons">
            <ul>
                ${buttons}
            </ul>
        </div>
    `;
    // By default.
    context.find('tr td:nth-child(2)').css('display', 'table-cell').addClass('active');
    // Update DOM.
    container.prepend(buttons);
    // Activate the first button.
    container.find('[comparison-table-button]').first().addClass('active');
    if (showSummaryRow) {
        let summary = `
            <tbody class="comparison-summary">
                <tr>
                    <td class="comparison-column-heading">${comparisonColumnHeading}</td>
                    <td class="comparison-currently-selected" comparison-currently-selected></td>
                </tr>
            </tbody
        `;
        // Insert after head.
        $(summary).insertAfter(context.find('> thead'));
    }
    // Update selected, as we're just initialising we know its going to be the first column.
    updateComparisonSelected(context, context.find('> thead tr > th:nth-child(2)').html());
    // Add Listener.
    container.find('[comparison-table-button]').on('click', function() {
        // Get button context.
        let button = $(this);
        // Table index.
        let index = button.attr('table-index');
        // Disable all other cells.
        context.find('.comparison-values td:not(:nth-child(1))').css('display', 'none').removeClass('active');
        // Enable the child cells that match the index on the button.
        context.find('.comparison-values td:nth-child(' + index + ')').css('display', 'table-cell').addClass('active');
        // Disable all other active classes.
        container.find('[comparison-table-button]').removeClass('active');
        // Add active class to current button.
        button.addClass('active');

        updateComparisonSelected(context, button.html());
    });

    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        // Get the numeric representation of the current breakpoint.
        let breakpoint = currentBreakpoint();
        if (breakpoint >= 3) {
            context.find('.comparison-values td').css('display', '').removeClass('active');
        } else {
            context.find('.comparison-values tr td:nth-child(2)').css('display', 'table-cell').addClass('active');
        }

    });
}

function updateComparisonSelected(context, value) {
    context.find('[comparison-currently-selected]').html(value);
}


function addMobileLabels(id) {
    // Get headings.
    let labels = instances[id]['labels'];
    // Column Count.
    let count = $(labels).length;
    // Loop through each of the columns adding their labels.
    $(labels).each(function() {
        // Find the column we're about to update.
        const columns = $('table[table-id=' + id +'] tbody tr').find('td:nth-child(' + count + ')');
        // Should we be ignoring this label?
        const ignore = labels[ count - 1 ]['ignore'];
        // Skip if we're ignoring this row.
        if (!ignore) {
            // If the label doesn't exist then create one.
            columns.each(function() {
                // Column context.
                const column = $(this);
                // Check if empty.
                const isEmpty = columnEmptyCheck(column);
                // If there are no children in the td then skip.
                if (!isEmpty) {
                    // Is there already a column label?
                    const labelExists = columnHasLabel(column);
                    // Do we need to update it? 
                    const heading = labels[ count - 1 ]['heading'];
                    if (labelExists) {
                        // If there is actually a heading assigned to the th, otherwise skip.
                        if (heading) {
                            column.find('[' + expressSelectors()['tables']['mobile-label'] + ']').html(heading);
                        }
                    } else if (heading) {
                        // Build markup.
                        const markup = `
                            <span class="col-label hide-for-large" ${expressSelectors()['tables']['mobile-label']}>
                                ${labels[ count - 1 ]['heading'] }
                            </span>
                        `;
                        // Update column with markup.
                        column.prepend(markup);
                    }
                }
            });
        }
        // Decrease count for next column.
        count--;
    })
    return true;
}

// Check if column is empty.
function columnEmptyCheck(column) {
    // Column children.
    const children = column.children();
    // Empty flag.
    const isEmpty = (!children.length && !column.text().trim().length);
    if (isEmpty) {
        // If there is no content then hide the td altogether to prevent excess spacing as mobile adopted a column like view.
        column.addClass('column-empty');
    }
    return isEmpty;
}

// Check if column has label.
function columnHasLabel(column) {
    const hasLabel = (column.find('[' + expressSelectors()['tables']['mobile-label'] + '], .col-label').length > 0);
    return hasLabel;
}

// Toggle input via row clicks.
function rowInputToggleInitialise(context) {
    if (!context) {
        console.error("Row Input Toggle: Please provide a toggle");
        return false;
    }
    // Get Id.
    // Get associated input name.
    const name = context.attr(expressSelectors()['tables']['row-input-toggle']);
    if (!name) {
        console.error("Row Input Toggle: Please provide the name of the associated input", context);
        return false;
    }
    // Find the input.
    let input = context.find('input[name="' + name + '"]');
    if (!input.length) {
        // Fallback to id due to grouped inputs with the same name.
        input  = context.find('input[id="' + name + '"]');
        if (!input.length) {
            console.error("Row Input Toggle: Could not find associated input", context);
            return false;
        }
    }
    // Get input type.
    const type = input.attr('type');
    if (!type) {
        console.error("Row Input Toggle: No type defined", input);
        return false;
    }
    // Check support inputs.
    if (!supportedRowControlToggleInputs.includes(type)) {
        console.error("Row Input Toggle: Sorry we only support the following input types", supportedRowControlToggleInputs);
        return false;
    }
    // Add classes.
    context.addClass('row-input-toggle');
    // Get value.
    let toggled = input.is(':checked');
    // Add click listener to row.
    context.on('click', function() {
        toggled = input.is(':checked');
        if (type == "radio") {
            // Do not allow unselecting a radio button.
            if (!toggled) {
                toggleInput(input, !toggled);
            }
        } else {
            toggleInput(input, !toggled);
        }
    });
    // To prevent bubbling a click listener needs to be added to the input itself, this shouldn't cause an issue for abide as that functions on either Change or Submit events.
    input.on('click', function(event) {
        console.warn("Row Input Toggle: Prevent propagation otherwise this will cause double click event's the row click listener.", input);
        return;
    });
    // Toggle input.
    function toggleInput(input, state) {
        // Invert value.
        input.prop('checked', state);  
        // Trigger change so if validation is applied that will kick in.
        input.trigger('change');
    }
}


var AXISTypography = $.AXISTypography = {
    initialiseAll: () => {
        let tables = initialiseAlltables();

        let comparisonInit = initialiseAllComparisionTables();

        return true;

    },
    initialise: (context) => {
        if (context.attr(expressSelectors()['cms']['tables']) != undefined) {
            let tables = initialiseTables(context);
        }
        if (context.attr(expressSelectors()['tables']['responsive-tables']) != undefined) {
            let responsiveTableInit = initialiseTables(context);
        }
        if (context.attr(expressSelectors()['tables']['comparison-tables']) != undefined) {
            let comparisonInit = comparisonTableInitialise(context)
        }
       
        
        return true;
    },
    initialiseAllComparisonTables: () => {
        return initialiseAllComparisionTables();
    },
    tableMobileLabels: (context) => {
        return addMobileLabels();
    }
}
 
export { AXISTypography };
